import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { DepartmentListComponent } from "./department-list/department-list.component";

const routes: Routes = [
  {
    path: "departments",
    component: DepartmentListComponent,
    canActivate: [AuthGuard],
  },
];

export const DepartmentsRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/departments.routes.ts